import posthog from 'posthog-js';

const key = import.meta.env.VITE_POSTHOG_KEY;
const host = import.meta.env.VITE_POSTHOG_HOST;

/* Starts PostHog. startAnalytics calls this only after the Stripe secrets leave the URL, so the
   first pageview never records them. In production events go through the Worker's /ingest proxy,
   which ad blockers do not recognise. */
export function startPostHog() {
  if (!key || !host) {
    if (import.meta.env.DEV)
      console.error(
        'VITE_POSTHOG_KEY and VITE_POSTHOG_HOST are required for PostHog; events are skipped.',
      );
    return;
  }
  posthog.init(key, {
    api_host: import.meta.env.DEV ? host : '/ingest',
    ui_host: host.replace('.i.posthog.com', '.posthog.com'),
    defaults: '2026-05-30',
    logs: {
      serviceName: 'rrroblox-web',
      environment: import.meta.env.MODE,
    },
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
  });
}

/* PostHog once started, otherwise undefined. */
export const posthogClient = () => (posthog.__loaded ? posthog : undefined);
